var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEGeneralBacs = function SvgEGeneralBacs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 60,
    width: 2,
    height: 9,
    fill: "#1c9d5b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 18.01,
    width: 42,
    height: 42,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,19.01v40h-40V19.01h40M363,18.01h-42v42h42V18.01h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342,24.38l15.2,12.94h-3.61v18.42h-23.17v-18.42h-3.61l15.2-12.94M342,22.68l-18.71,15.93h5.83v18.42h25.76v-18.42h5.83l-18.71-15.93h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M355.63,30.96l-1.5.04-.02-.75c-.03-1.01-.33-1.75-.87-2.19-.93-.74-2.35-.49-2.36-.49l-.72.14v-1.52l.43-.09c.09-.01,2.1-.4,3.57.77.91.73,1.39,1.84,1.44,3.32l.02.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.2,30.24v.75h-1.5v-.75c0-1.79-.5-3.14-1.5-4-1.71-1.49-4.34-1.13-4.37-1.13l-.68.1v-1.51l.47-.07c.13-.02,3.34-.45,5.56,1.48,1.33,1.16,2.01,2.88,2.01,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,30.24v.75h-1.5v-.75c0-2.6-.73-4.56-2.18-5.84-2.43-2.15-6.14-1.72-6.18-1.72l-.67.08v-1.51l.49-.06c.18-.02,4.4-.52,7.35,2.07,1.79,1.58,2.69,3.92,2.69,6.97h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "325.87 21.14 323.38 28.55 325.13 28.55 323.29 35.46 329.12 25.55 326.54 25.46 328.56 21.14 325.87 21.14"
  })))));
};
export default SvgEGeneralBacs;